import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '@praxis/component-auth';
import { useInstallerAuthContext } from '../../hooks/useInstallerAuthContext';
import { getExternalToken } from '../../utils/authHelpers';
import { Grid, Image } from '@enterprise-ui/canvas-ui-react';
import { LayoutTagWalk } from '../LayoutTagWalk';

import rfidTag from '../../common/graphics/red-rfid-card.svg?url';

import styles from './TagWalkPage.module.scss';
import {
  startCalibration,
  startCalibrationExt,
} from '../../app/calibration/startCalibrationSlice';

export const SetupTagPage = () => {
  const auth = useAuth();
  const { session } = auth;
  const { user } = useInstallerAuthContext();
  const dispatch = useDispatch();

  const [token, setToken] = useState('');
  const location = useSelector(
    (state) => state.calibration.activeReaderDetails.storeId,
  );

  useEffect(() => {
    setToken(getExternalToken(user));
  }, [user]);

  useEffect(() => {
    if (location) {
      if (session) {
        dispatch(startCalibration(location));
      } else if (user && token) {
        dispatch(startCalibrationExt({ location, token }));
      }
    }
  }, [session, user, token, dispatch, location]);
  return (
    <>
      <LayoutTagWalk
        pageTitle="Reader Calibration | Setup"
        activeSetup={true}
        nextPage={'/calibrationSetupReader'}
        prevPage={'/calibrationSetupLocation'}
      >
        <Grid.Item xs={12}>
          <p className="hc-ta-center hc-fs-md">
            To begin Calibration, you will need the test RFID card provided to
            you.
          </p>
        </Grid.Item>
        <Grid.Item xs={12}>
          <Image
            alt="Close-up of hand holding red RFID test card"
            src={rfidTag}
            height="14.5em"
            width="14em"
            type="contain"
            className={styles.centeredRfidTag}
          />
        </Grid.Item>
      </LayoutTagWalk>
    </>
  );
};
